/**
 * App country list — Ghana only for now.
 * Use instead of useCountries() from use-react-countries.
 */

export const APP_COUNTRIES = [
  {
    id: 'gh',
    name: 'Ghana',
    emoji: '🇬🇭',
    countryCallingCode: '+233',
  },
]

export const useAppCountries = () => ({ countries: APP_COUNTRIES })

export const getGhanaCountryOption = () => ({
  label: '🇬🇭 +233',
  value: 'Ghana',
  countryLabel: 'Ghana',
  countryCallingCode: '+233',
})
